import React from "react"
import PropTypes from "prop-types"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap"

import { format } from "date-fns";
import { fr } from "date-fns/locale";


import img7 from "../../assets/images/product/img-7.png"
import img4 from "../../assets/images/product/img-4.png"

const ShowInvoiceModal = props => {
//const ShowInvoiceModal = ({ isOpen, toggle, invoice }) => {
  const { isOpen, toggle, invoice  } = props;

  //if (!invoice) return null; // ou afficher un loader

  


  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>Détails facture</ModalHeader>
        <ModalBody>
          <p className="mb-2">
            Réf: <span className="text-primary">{invoice?.uid}</span>
          </p>
          <p className="mb-4">
            Date: <span className="text-primary">{invoice?.created_at ? format(invoice.created_at, "dd/MM/yyyy", { locale: fr }) : ""}</span>
          </p>
          <p className="mb-4">
            Réf. Client: <span className="text-primary">{invoice?.account.uid}</span>
          </p>

          <div className="table-responsive">
            <Table className="table align-middle table-nowrap">
              <thead>
                <tr>
                  
                  <th scope="col">Libellé</th>
                  <th scope="col">Quantité</th>
                  <th scope="col">Prix</th>
                  <th scope="col">Montant</th>
                </tr>
              </thead>
              <tbody>
               {invoice?.invoice_items.length > 0 ? (
                invoice?.invoice_items.map((item) => (
                  <tr key={item.id}>
                    <td>{item.purchasable.name}</td>
                    <td>{item.quantity}</td>
                    <td>{item.unit_price} </td>
                    <td>{item.amount} </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center text-muted">
                    Aucun article trouvé
                  </td>
                </tr>
              )}

              <tr>
                <td colSpan="3" className="text-end">
                  <strong>Total HT :</strong>
                </td>
                <td>{invoice?.total_excl_tax}</td>
              </tr>

              <tr>
                <td colSpan="3" className="text-end">
                  <strong>Total TTC: </strong>
                </td>
                <td>
                  <strong> {invoice?.total_incl_tax}</strong>
                </td>
              </tr>
              </tbody>
            </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={toggle}>
            Fermer
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

ShowInvoiceModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default ShowInvoiceModal
